import { useState, forwardRef } from 'react';
import styles from './styles.module.css';

const SearchBar=forwardRef(({
    wrapStyle=null,
    inputStyle=null,
    iconStyle=null,
    placeholder="Search",
    onChange=null,
    onClear=null,
    onFocus=null,
    onBlur=null,
},ref)=>{
    const [inputValue,setInputValue]=useState(null);
    const [isInputClear,setIsInputClear]=useState(false);
    const [isSearch,setIsSearch]=useState(false);

    const handleKeyDown=(e)=>{
        if(e.keyCode===27){
            handleInputClear();
            handleBlur(e)
            ref?.current.blur();
            return;
        }
    }

    const handleInputChange=(e)=>{
        if(onChange)onChange(e.target.value)
        setInputValue(e.target.value);

        if(e.target.value.trim()===""){
          setIsInputClear(false);
        }

        if(e.target.value.trim()!==""){
          setIsInputClear(true);
        }
    }

    const handleInputClear=()=>{
        if(onClear)onClear();
        setInputValue("");
        setIsInputClear(false);
    }

    const handleFocus=(e)=>{
        if(onFocus)onFocus(e);
        setIsSearch(true);
    }

    const handleBlur=(e)=>{
        if(onBlur)onBlur(e);
        setIsSearch(false);
    }

    return(
        <div className={`${styles['search']} ${isSearch&&styles['search-on']} ${wrapStyle}`}>
            <div className={`${styles['icon']} ${iconStyle}`}></div>
            <input ref={ref} className={`${styles['input']} ${inputStyle}`} 
            type='text'
            value={inputValue}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange} 
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={placeholder}></input>
            {isInputClear&&<div className={styles['input-clear']} onClick={handleInputClear}></div>}
        </div>
    )
})

export default SearchBar;